<div class="actionwrapper">
    <mat-form-field class="search">
        <mat-label>Search</mat-label>
        <input class="search" #search matInput placeholder="Search by vendor product, company, metadata...">
    </mat-form-field>
    <div class="actions">
        <button mat-raised-button color="primary" (click)="addItem()">
            <mat-icon>add</mat-icon>
            Add new group product
        </button>
    </div>
</div>
<table class="table" mat-table matSort [dataSource]="items">
    <ng-container matColumnDef="createdAt">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Created At</th>
        <td class="cell" mat-cell *matCellDef="let item">{{item.createdAt | date: 'medium'}}</td>
    </ng-container>
    <ng-container matColumnDef="vendorProductName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Vendor Product</th>
        <td class="cell" mat-cell *matCellDef="let item">{{item.vendorProductName}}</td>
    </ng-container>
    <ng-container matColumnDef="metadata.shortName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Short Name</th>
        <td class="cell" mat-cell *matCellDef="let item">{{item.metadata.shortName}}</td>
    </ng-container>
    <ng-container matColumnDef="metadata.tag">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Tag</th>
        <td class="cell" mat-cell *matCellDef="let item">{{item.metadata.tag}}</td>
    </ng-container>
    <ng-container matColumnDef="metadata">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Metadata</th>
        <td class="cell" mat-cell *matCellDef="let item">{{truncateJSONString(item.metadata, 500)}}</td>
    </ng-container>
    <ng-container matColumnDef="actionmenu" stickyEnd>
        <th mat-header-cell matTooltip="Actions" *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let item"><button mat-button class="cell" [matMenuTriggerFor]="menu" [matMenuTriggerData]="{item: item}"><mat-icon matTooltip="Actions" class="more">more_vert</mat-icon></button></td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="allColumnNames"></tr>
    <tr class="listitem" mat-row *matRowDef="let rows; columns: allColumnNames"></tr>
    <mat-menu #menu="matMenu">
        <ng-template matMenuContent let-item="item">
            <button mat-menu-item (click)="editItem(item)">Edit</button>
            <button mat-menu-item (click)="duplicateItem(item)">Duplicate</button>
            <button mat-menu-item (click)="removeItem(item)">Remove</button>
        </ng-template>
    </mat-menu>
</table>
